export default "__VITE_ASSET__BSM$AovC__"